export default {
  Email: 'E-mail',
  ConfirmEmail: "Confirmer l'E-mail",
  Password: 'Mot de passe',
  Verificationcode: 'Code de vérification',
  AlreadyhaveaHitPawaccountLogin:
    'Vous avez déjà un compte HitPaw ? Connectez-vous',
  ByproceedingyouagreetoourServicesofUseandPrivacyPolicy1:
    "En vous inscrivant, vous acceptez l'Utilisation de nos Services et notre Politique de Confidentialité",
  ByproceedingyouagreetoourServicesofUseandPrivacyPolicy2:
    "En vous connectant, vous acceptez l'Utilisation de nos Services et notre Politique de Confidentialité.",
  Byproceedingyouagreetoour: 'En vous inscrivant, vous acceptez ',
  ServicesofUse: "l'Utilisation de nos Services",
  and: ' et ',
  PrivacyPolicy: 'notre Politique de Confidentialité',
  last: '.',
  TheEmailformatisincorrect: "Le format de l'e-mail est incorrect",
  Pleaseenterthesameemailinbothfields:
    "L'adresse e-mail saisie deux fois eat incohérente",
  Thepasswordmustbe850charactersandcontainatleasttwocategoriesamongthefollowingnumberletterorspecialcharacter:
    'Les mots de passe doivent comporter de 8 à 50 caractères et contenir au moins deux des catégories suivantes : chiffres, lettres ou caractères spéciaux.',
  Incorrectverificationcode: 'Erreur de saisie du code de vérification',
  ThisEmailhasbeenregisteredpleasechooseanother: "L'email est déjà enregistré",
  Cannotbeemptyhere: 'Il ne peut pas être vide',
  Rememberme: 'Mémorisez votre mot de passe',
  ForgotPassword1: 'Vous avez oublié votre mot de passe ?',
  NotaregistereduseryetSignUp: "Vous n'êtes pas encore inscrit ? S'inscrire",
  Notaregistereduseryet1: "Vous n'êtes pas encore inscrit ? ",
  Notaregistereduseryet2: "S'inscrire",
  NoaccountfoundwiththatEmailaddress: "L'e-mail n'existe pas",
  YourEmailaddressorpasswordwasincorrectPleasetryagain:
    "L'adresse e-mail ou mot de passe erroné, veuillez le saisir à nouveau.",
  ForgotPassword2: 'Cliquez Oublier le mot de passe',
  GetVerificationCode: 'Obtenir le code de vérification',
  VerifyEmail: "Vérifier l'e-mail",
  Ithasbeensenttoyourmailboxpleasecheckit:
    'Il a été envoyé à votre adresse électronique, veuillez le vérifier.',
  PleaseinputEmailaddress: 'Veuillez entrer votre adresse e-mail',
  TheEmailisnotregistered: "L'adresse e-mail n'est pas enregistrée",
  Invalidverificationcodepleasereenterthecorrectone:
    'Le code de vérification est incorrect, veuillez le saisir à nouveau',
  Resetpassword: 'Réinitialiser le mot de passe',
  Emailaddressverificationsucceeded:
    'Vérification de la boîte aux lettres réussie',
  Pleaseresetyourpassword: 'Veuillez réinitialiser votre mot de passe',
  Enteranewpassword: 'Entrez le nouveau mot de passe',
  Confirm: 'Confirmer',
  Newpasswordshouldbe850characterslongcomposedoflettersornumbersoramixtureoflettersnumbers:
    "Le nouveau mot de passe doit comporter de 8 à 50 caractères, composés de lettres ou de chiffres ou d'un mélange de lettres et de chiffres.",
  Passwordresetsuccessfully: 'Réinitialisation du mot de passe réussie',
  Name: 'Nom',
  GetCode: 'Obtenir le code',
  Loginsuccessful: 'Connexion réussie',
  Loginfailed: 'Échec de la connexion',
  Signupsuccessful: 'Inscription réussie',
  Signupfailed: "Échec de l'enregistrement",
  Getpassword: 'Obtenir le mot de passe',
  Authorizationhasexpiredpleaseloginagain:
    "L'autorisation a expiré, veuillez vous reconnecter.",
  Sorrysomethingwentwrongpleasetryagainlater:
    "Désolé, quelque chose s'est mal passé, veuillez réessayer plus tard.",
  Toomanysamerequestsweremadeinashortperiodoftimepleasetryagainlater:
    'Trop de demandes identiques ont été faites dans un court laps de temps, veuillez réessayer plus tard.',
  Couldntfindyouraccountorthepasswordisincorrect:
    "Votre compte n'a pas été trouvé, ou le mot de passe est incorrect.",
  Youaretryingtoaccessapaidfunctionpleasesubscribefirst:
    "Vous essayez d'accéder à une fonction payante, veuillez vous abonner d'abord.",
  Accessdeniedfortheunauthorizedrequest:
    'Accès refusé pour la demande non autorisée.',
  Alreadyhaveaccount: 'Vous avez déjà un compte?',
  SignUpwithemail: 'Inscription par courriel',
  Securityverification: 'Vérification de la sécurité',
  Pleaseenterthecorrectemailaddress:
    "Veuillez saisir l'adresse e-mail correcte !",
  PleaseInputverificationCode: 'Veuillez entrer le code de vérification !',
  Pleaseenterthesamepasswordinbothfields:
    'Veuillez saisir le même mot de passe dans les deux champs !',
  or: 'Ou',
  ThenewpasswordyouenteredisthesameasyouroldpasswordEnteradifferentpassword:
    "Entrez le nouveau mot de passe avec l'ancien, veuillez entrer un mot de passe différent",
  YourpasswordwasincorrectPleasetryagain:
    "Le mot de passe n'est pas correct, veuillez réessayer",
  reg400:
    "Désolé, quelque chose s'est mal passé, veuillez réessayer plus tard.",
  reg400223: "L'e-mail et le code ne correspondent pas, veuillez vérifier.",
  reg400224: 'Token a expiré',
  500: 'Erreur côté serveur!',
  Afewsecondsaway: 'Connectez-vous ou inscrivez-vous en quelques secondes',
  ContinuewithGoogle: 'Continuer avec Google',
  ContinuewithEmail: 'Continuer avec e-mail',
  LoginwithEmail: 'Connectez-vous avec e-mail',
  Usemorethan8charactersandmixlettersnumbersandsymbols:
    'Utilisez plus de 8 caractères avec un mélange de lettres, de chiffres et de symboles (symboles pris en charge : @$!%*#_~?&^)',
  ConfirmPassword: 'Confirmer le mot de passe',
  Pleaseloginwithemail: 'Veuillez vous connecter avec e-mail',
  youraccount: 'Votre compte',
  alreadyexiststoensurethesecuritypleaseverifyitfirst:
    "existe déjà, pour assurer la sécurité de votre compte, veuillez d'abord effectuer la vérification.",
  Login: 'Se connecter',
  exceed6Times:
    "Votre essai est terminé aujourd'hui, veuillez passer à Pro pour accéder à toutes les fonctionnalités premium.",
  exced20M:
    'La taille du fichier pour les comptes gratuits ne peut pas dépasser 20 Mo, veuillez passer à Pro pour accéder à toutes les fonctionnalités premium.',
  403102: 'Le compte Google a été lié à un autre compte',
};
